import PortfolioManualTradeDetailChart from './PortfolioManualTradeDetailChart';

export default PortfolioManualTradeDetailChart;
